/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AslDTO } from './aslDTO';
import { AslRegionDTO } from './aslRegionDTO';
import { NeighborhoodDTO } from './neighborhoodDTO';
import { ProvinceDTO } from './provinceDTO';


export interface CityDTO { 
    /**
     * The asl to which the city belongs 
     */
    asl?: AslDTO;
    /**
     * The region to which the city belongs 
     */
    aslRegion?: AslRegionDTO;
    /**
     * The city's post code 
     */
    cap?: string;
    /**
     * The city's cfis 
     */
    cfis?: string;
    /**
     * The city's code
     */
    code?: string;
    /**
     * The city's creation date
     */
    createDate?: Date;
    /**
     * The create user's uuid
     */
    createUserId?: string;
    /**
     * The city's description
     */
    description?: string;
    /**
     * The city's end date
     */
    endDate?: Date;
    /**
     * The city's neighborhoods
     */
    neighborhoods: Array<NeighborhoodDTO>;
    /**
     * The city's obsolete 
     */
    obsolete?: boolean;
    /**
     * The province to which the city belongs 
     */
    province?: ProvinceDTO;
    /**
     * The city's start date.
     */
    startDate?: Date;
    /**
     * The city's update date
     */
    updateDate?: Date;
    /**
     * The update user's uuid
     */
    updateUserId?: string;
    /**
     * The city's uuid
     */
    uuid?: string;
}
